import { IButtonStyles, memoizeFunction } from '@fluentui/react';

import { AppGalleryStyles } from '@1js/acui-gallery';

const largePreviewGalleryHeight = 62;
const borderWidth = 1;

const galleryButtonStyles: IButtonStyles = {
  root: {
    height: largePreviewGalleryHeight - 2 * borderWidth, // Subtract top and bottom border width
    width: 76,
    boxSizing: 'border-box',
    borderRadius: 'unset',
  },
};

export const getLargePreviewGalleryStyles = memoizeFunction(
  (shouldAlignPreviewGalleryVertically?: boolean): Partial<AppGalleryStyles> => {
    return {
      galleryContainer: {
        root: {
          height: largePreviewGalleryHeight,
          marginTop: !!shouldAlignPreviewGalleryVertically ? 3 : 8,
        },
      },
      galleryButtonInPreview: galleryButtonStyles,
      galleryButtonInExpanded: galleryButtonStyles,
      previewExpandButton: {
        root: {
          height: largePreviewGalleryHeight - 2 * borderWidth, // Subtract top and bottom border width
          width: 16,
        },
        icon: {
          width: 8,
          height: 8,
          lineHeight: 8,
        },
      },
    };
  }
);
